define('rebrush/components/blocks/discount-code',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'rebrush/system/layout/responsive-hub',
    'lodash',
    'rebrush/system/animation',
    'modernizr'
], function(
    $,
    Component,
    BEM,
    ResponsiveHub,
    _,
    Animation
) {
    var BLOCK_NAME = 'discount-code';

    var MODIFIER_OPEN       = 'open',
        MODIFIER_OPENING    = 'opening';

    var endPrecedingAnimation = $.noop;
    var isMobile = true;

    function DisountCodeBox(block) {
        this.block = BEM.block(block);
        this.trigger = this.block.getElements('trigger');
        this.content = this.block.getElements('content');
        this.init();
    }

    DisountCodeBox.prototype = {
        init: function() {
            this.bindEvents();
        },

        bindEvents: function() {
            var self = this;

            this.trigger.on('click', function(e) {
                e.preventDefault();
                self.toggle();
            });

            ResponsiveHub
                .on('change.mobile.enter', function() { isMobile = true; })
                .on('change.mobile.leave', function() { isMobile = false; });
        },

        toggle: function() {
            if (this.block.bemHasModifier(MODIFIER_OPEN)) {
                this.close();
            } else {
                this.open();
            }
        },

        open: function() {
            var targetHeight;
            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                this.content.css('height', '');
                this.block.bemRemoveModifier(MODIFIER_OPENING);
                this.block.bemAddModifier(MODIFIER_OPEN);
            }, this);

            this.block.bemAddModifier(MODIFIER_OPENING);
            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                this.content.css('height', 'auto');
                targetHeight = this.content.height();
                this.content.css('height', '');
                _.defer(_.bind(function() {
                    this.content.one(Animation.transitionEndEventName, onAnimationEnd);
                    this.content.css('height', targetHeight);
                }, this));
            } else {
                onAnimationEnd();
            }

            this.block.find('[name="coupon_code"]').focus();
        },

        close: function() {
            var onAnimationEnd = _.bind(function() {
                endPrecedingAnimation = $.noop;
                this.content.css('height', '');
                this.content.css('opacity', '');
                this.block.bemRemoveModifier(MODIFIER_OPEN);
            }, this);

            if (!isMobile && Animation.supportAnimations) {
                endPrecedingAnimation();
                endPrecedingAnimation = onAnimationEnd;
                this.content.css('height', this.content.height());
                _.defer(_.bind(function() {
                    this.content.one(Animation.transitionEndEventName, onAnimationEnd);
                    this.content.css('height', 0);
                    this.content.css('opacity', 0);
                }, this));
            } else {
                onAnimationEnd();
            }
        }
    };

    return Component.create({
        $init: function() {
            BEM.block(BLOCK_NAME).each(function() {
                new DisountCodeBox(this);
            });
        }
    });
});
